import { useState, useEffect, useRef, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'


const FormIngreso = () => {
    const [importe, setImporte] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const { setFormView, setViewOpen, formPrev, idUsuario } = useContext(ContextStates)


    const guardarDatos = async (event) => {
        event.preventDefault();
        const formData = new FormData()
            formData.append('importe', importe);
            formData.append('descripcion', descripcion);
            formData.append('usuario', idUsuario);
            try {
                const results = await axios({
                    url: Url + 'api/formIngreso.php',
                    method: 'POST',
                    data: formData,
                })
                setImporte('')
                setDescripcion('')
                setViewOpen(false)
                console.log(results)
            } catch (e) {
                console.log(e)
            }
    }

    return (
        <form
            className="w-full py-5 px-20 rounded-2xl"
            onSubmit={guardarDatos}
        >
            <div className="transition-all w-full pt-5 sm:p-3 mt-5">
                <h2 className='text-center text-gray-700 text-xl uppercase'>Ingreso de dinero</h2>
                <div className="sm:items-start">
                    <label htmlFor="descripcion" className="w-full block mt-5 text-black uppercase font-bold">Importe</label>
                    <input
                        className="py-2 px-3 w-full border border-gray-300 rounded"
                        id="importe"
                        placeholder="Importe"
                        type="text"
                        value={importe}
                        onChange={(e)=>setImporte(e.target.value)}
                        autoFocus
                    />
                </div>
                <div className="sm:items-start">
                    <label htmlFor="descripcion" className="w-full block mt-5 text-black uppercase font-bold">Descripción</label>
                    <input
                        className="py-2 px-3 w-full border border-gray-300 rounded"
                        id="descripcion"
                        placeholder="Descripción"
                        type="text"
                        value={descripcion}
                        onChange={(e)=>setDescripcion(e.target.value)}
                    />
                </div>
            </div>
            <div className="pb-10">
                <div className="w-full rounded-lg px-3">
                    <input
                        type="submit"
                        className="w-full shadow-md p-3 bg-orange-600 text-gray-100 hover:text-gray-300 transition-all uppercase font-bold rounded-lg mt-5"
                        value="Cargar ingreso"
                    />
                    {formPrev !== 0 && (
                        <button
                            className="w-full shadow-md p-3 bg-gray-600 text-gray-100 hover:text-gray-300 transition-all uppercase font-bold rounded-lg mt-5"
                            onClick={()=>setFormView(formPrev)}
                        >
                            Volver
                        </button>
                    )}
                </div>
            </div>
        </form>
    )
}

export default FormIngreso